import { create } from 'zustand';

interface UIState {
  /** Whether the sidebar is open (desktop) */
  sidebarOpen: boolean;
  /** Currently active navigation section */
  activeSection: 'messages' | 'sets' | 'tasks' | 'kit';
  /** Toggle sidebar visibility */
  toggleSidebar: () => void;
  /** Set the active navigation section */
  setActiveSection: (section: 'messages' | 'sets' | 'tasks' | 'kit') => void;
  /** Set sidebar open state directly */
  setSidebarOpen: (open: boolean) => void;
}

export const useUIStore = create<UIState>((set) => ({
  sidebarOpen: true,
  activeSection: 'messages',
  toggleSidebar: () => set((state) => ({ sidebarOpen: !state.sidebarOpen })),
  setActiveSection: (section) => set({ activeSection: section }),
  setSidebarOpen: (open) => set({ sidebarOpen: open }),
}));
